import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Comp>
  );
};

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono-tech text-xs uppercase tracking-[0.28em] text-[var(--gold-text)] flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-gold-grad" />
    {children}
  </p>
);
